import { useDispatch } from 'react-redux';
import descriptionAlertSlice from './descriptionAlertSlice.ts';
import { useCallback, useState, useEffect } from 'react';
import { AlertTypeEnum } from './AlertTypeEnum';
import { t } from "@lingui/core/macro";

const SUCCESS_TIMEOUT_MS = 10000;
const FAIL_TIMEOUT_MS = 30000;

export default function useDescriptionAlert() {
  const dispatch = useDispatch();
  const [timer, setTimer] = useState<NodeJS.Timeout | null>(null);
    
  const openSuccessAlert = useCallback(
    (body: string) => {
        if (timer) {
            clearInterval(timer)
            setTimer(null)
        }
      setTimer(setTimeout(closeAlert, SUCCESS_TIMEOUT_MS))
      dispatch(
        descriptionAlertSlice.actions.open({
          type: AlertTypeEnum.SUCCESS,
          title: t`Success`,
          body,
          open: true,
        }),
      );
    },
    [dispatch],
  );

  const openFailAlert = useCallback(
    (body: string) => {
        if (timer) {
            clearInterval(timer)
            setTimer(null)
        }
      setTimer(setTimeout(closeAlert, FAIL_TIMEOUT_MS))
      dispatch(
        descriptionAlertSlice.actions.open({
          type: AlertTypeEnum.ERROR,
          title: t`Error`,
          body,
          open: true,
        }),
      );
    },
    [dispatch],
  );

  const closeAlert = useCallback(() => {
    dispatch(descriptionAlertSlice.actions.close());
    if (timer) {
      clearInterval(timer)
      setTimer(null)
    }
  }, [dispatch]);
    
  return { openSuccessAlert, openFailAlert, closeAlert };
}
